import(/* webpackMode: "eager" */ "/Users/chenyingsun/Desktop/Works/01 My Company/01 YiQi/03 development/yiqi-creator-mvp/src/app/about/page.tsx");
